var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.42 63.13h61.82M.42 1.31H25m-24.58 4H25m-24.58 4h12.57",
    stroke: "#FFF",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42 51.13h12.67v12H6.42zM44.58 1.31v61.82h11.66V1.31zM25 32.22h12.67v30.91H25z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 63.13v-12h12.66v12m24.74 0V1.31h11.67v61.82m-30.87 0V32.22h12.67v30.91",
    stroke: "#FFF",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile2);
export default __webpack_public_path__ + "static/media/Mobile2.bfda4ee9ef9a41eeda6b432e3bce8a43.svg";
export { ForwardRef as ReactComponent };